"use strict";

PF.Dom = class Dom //extends PF.Entity
	{
	constructor(object)
		{
		// super();
		for (let key in object)
			{
			this[key] = object[key];
			}
		this.html = {};
		// PF.H.useTrait(PF.EventsTrait);
		}


	load(html, name = undefined)
		{
		let dom = new PF.Dom.Node(html);
		this.process(dom);
		if (name !== undefined)
			{
			this.html[name] = html;
			this[name] = dom;
			}
		}

	process(element)
		{
		let elements = element.find('[pf]');
		for (let i = 0; i < elements.length; i++)
			{
			let name = elements[i].node.getAttribute('pf');
			this.html[name] = elements[i].html;
			this[name] = elements[i];
			}
		if (element.node.hasAttribute('pf'))
			{
			let name = element.node.getAttribute('pf');
			this.html[name] = element.html;
			this[name] = element;
			}
		}

	collectHtml(element, html)
		{
		let templates = new PF.Dom();
		templates.processToHtml(element);
		element.empty();
		Object.assign(html, templates.html);
		}

	processToHtml(element)
		{
		let elements = element.find(':scope > [pf]');
		for (let i = 0; i < elements.length; i++)
			{
			let name = elements[i].node.getAttribute('pf');
			this.html[name] = elements[i].getHtml();
			}
		}

	loads(templates)
		{
		for (let name in templates)
			{
			if (typeof templates[name] === "string")
				{
				this.load(templates[name], name);
				}
			}
		}

	destroy()
		{
		for (let key in this)
			{
			if (this[key] instanceof PF.Dom.Node)
				{
				this[key].destroy();
				this[key] = undefined;
				}

			}
		}
	};